<template>
  <div class="back" :style="{ color: titleColor }">
    <div class="jiantou" @click="goBack">
      <img :src="backUrl" alt class="back_bg" />
    </div>
    <div class="content">{{ title }}</div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '标题',
    },
    titleColor: {
      type: String,
      default: '#fff',
    },
    backUrl: {
      type: String,
      default: require('../common/images/recommend/back.png'),
    },
  },
  methods: {
    goBack() {
      this.$router.back();
    },
  },
};
</script>

<style lang="scss" scoped>
.back {
  height: 100%;
  width: 100%;
  display: flex;
  position: relative;
  .jiantou {
    width: 50px;
    height: 50px;
    position: absolute;
    left: 30px;
    top: 0;
    bottom: 0;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    .back_bg {
      width: 20px;
      height: 30px;
    }
  }
  .content {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 36px;
  }
}
</style>
